/**
 * Approval route inherited from the IRB workflow module.
 * Stage names and timing follow the institutional IRB flow chart.
 */
export interface ApprovalStage {
  id: string;
  label: string;
  timing: string;
  detail: string;
  outcomes?: string[];
}

export const APPROVAL_STAGES: ApprovalStage[] = [
{
  id: 'submission',
  label: 'Submission on Research Portal',
  timing: 'On submission',
  detail: 'Proposal received and an IRB number is generated automatically.'
},
{
  id: 'src-office',
  label: 'Scientific Research Committee Office',
  timing: 'Within 3 working days',
  detail: 'Completeness check before the proposal is tabled for scientific review.'
},
{
  id: 'src-review',
  label: 'Scientific Research Committee Review',
  timing: '1st Wednesday of every month',
  detail: 'Scientific merit reviewed by the committee.',
  outcomes: ['Processed', 'Minor revisions — resubmission', 'Major revision — resubmission']
},
{
  id: 'rc-office',
  label: 'Research Committee Office',
  timing: 'After scientific clearance',
  detail: 'Processed proposals are forwarded to the IRB Office.'
},
{
  id: 'irb-office-intake',
  label: 'IRB Office',
  timing: 'Before the 15th of every month',
  detail:
  'Proposal received from the Scientific Research Committee Office and placed on the IRB agenda.'
},
{
  id: 'irb-meeting',
  label: 'IRB Meeting',
  timing: '3rd Wednesday of every month',
  detail: 'Ethical review by the full board.',
  outcomes: ['Approved', 'Minor revisions — resubmission', 'Major revisions — resubmission', 'Declined']
},
{
  id: 'irb-office-decision',
  label: 'IRB Office',
  timing: '3 working days',
  detail: 'Decision recorded and the approval letter prepared.'
},
{
  id: 'letter',
  label: 'Letter Issued',
  timing: '2 working days',
  detail: 'Ethical approval letter issued to the Principal Investigator.'
}];


export function stageIndex(id: string): number {
  return APPROVAL_STAGES.findIndex((stage) => stage.id === id);
}